module.exports = __webpack_public_path__ + "img/cafe-cappuccino.4a0f2fa2.jpeg";